import React from 'react';
import { ConfigContainer } from '../common/style/Common.style';
import ZerosixConfigCreateForm from './ZerosixConfigCreateForm/ZerosixConfigCreateForm';
import ZerosixConfigUpdateForm from './ZerosixConfigUpdateForm/ZerosixConfigUpdateForm';
import { PanelTitle, PanelText, ConfigWrapper, SuccessMessage } from './ZerosixLoyaltyIntegration.style';
import Modal from '@/components/atoms/Modal';
import { ActionBar } from '@/components/atoms/ActionBar';
import { Button } from '@/components/atoms/Button';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import useCreateZerosixConfig from './ZerosixConfigCreateForm/useCreateZerosixConfig';
import useUpdateZerosixConfig from './ZerosixConfigUpdateForm/useUpdateZerosixConfig';
import useZerosixLoyaltyIntegrationVM from './ZerosixLoyaltyIntegrationVM';
import Loader from '@/components/atoms/Loader';
const ZerosixLoyaltyIntegration = () => {
    const { restaurantId } = useParams<{ restaurantId: string; brandId: string }>();
    const { hasZerosixConfig, loyaltyConfig, isLoading, isDeleting, isModalOpen, setIsModalOpen, deleteConfig } =
        useZerosixLoyaltyIntegrationVM();
    const { onSubmit, control, handleSubmit, isCreating, isDirty: isCreateDirty } = useCreateZerosixConfig();
    const {
        onSubmit: onUpdateSubmit,
        control: updateControl,
        handleSubmit: updateHandleSubmit,
        isUpdating,
        isDirty: isUpdateDirty,
        isValid: isUpdateValid,
        isUpdateSuccess,
    } = useUpdateZerosixConfig();

    const handleSave = () => {
        if (hasZerosixConfig) {
            updateHandleSubmit(onUpdateSubmit)();
        } else {
            handleSubmit(onSubmit)();
        }
    };
    return (
        <ConfigWrapper>
            <ConfigContainer>
                <div>
                    <PanelTitle text="zerosix.title" />
                    <PanelText text="zerosix.description" />
                </div>
                <div>
                    {isLoading ? (
                        <Loader withContainer />
                    ) : !hasZerosixConfig ? (
                        <ZerosixConfigCreateForm
                            control={control}
                            canChangeProvider={!loyaltyConfig?.provider || loyaltyConfig?.provider === 'zerosix'}
                        />
                    ) : (
                        <ZerosixConfigUpdateForm control={updateControl} loyaltyConfig={loyaltyConfig} />
                    )}
                </div>
            </ConfigContainer>
            <Modal
                isOpen={isModalOpen}
                title="zerosix.deleteModal.title"
                onHide={() => setIsModalOpen(false)}
                width={500}
                buttons={[
                    <Button
                        buttonType="red"
                        onClick={() => {
                            deleteConfig({ restaurantId: Number(restaurantId) });
                            setIsModalOpen(false);
                        }}
                        isLoading={isDeleting}
                    >
                        <FormattedMessage id="button.delete" />
                    </Button>,
                ]}
            >
                <p>
                    <FormattedMessage id="zerosix.deleteModal.text" />
                </p>
            </Modal>
            <ActionBar>
                {isUpdateSuccess && (
                    <SuccessMessage>
                        <FormattedMessage id="zerosix.update.success" />
                    </SuccessMessage>
                )}
                {hasZerosixConfig && (
                    <Button buttonType="red" onClick={() => setIsModalOpen(true)} isLoading={isDeleting}>
                        <FormattedMessage id="button.delete" />
                    </Button>
                )}

                <Button
                    buttonType="primary"
                    disabled={!((isUpdateDirty && isUpdateValid) || isCreateDirty)}
                    onClick={handleSave}
                    isLoading={isCreating || isUpdating}
                >
                    <FormattedMessage id="button.save" />
                </Button>
            </ActionBar>
        </ConfigWrapper>
    );
};

export default ZerosixLoyaltyIntegration;
